var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_123_15165)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7483 13.5576C22.8688 13.2216 23.3499 13.2216 23.4705 13.5576L23.8001 14.4764C23.8387 14.5839 23.9244 14.6686 24.0333 14.7067L24.9636 15.0322C25.3038 15.1513 25.3038 15.6265 24.9636 15.7455L24.0333 16.0711C23.9244 16.1092 23.8387 16.1938 23.8001 16.3014L23.4705 17.2202C23.3499 17.5562 22.8688 17.5562 22.7483 17.2202L22.4186 16.3014C22.38 16.1938 22.2944 16.1092 22.1855 16.0711L21.2552 15.7455C20.9149 15.6265 20.9149 15.1513 21.2552 15.0322L22.1855 14.7067C22.2944 14.6686 22.38 14.5839 22.4186 14.4764L22.7483 13.5576Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3843 17.6402C26.4646 17.4162 26.7854 17.4162 26.8657 17.6402L27.0855 18.2528C27.1112 18.3245 27.1683 18.3809 27.2409 18.4063L27.8611 18.6233C28.088 18.7027 28.088 19.0195 27.8611 19.0989L27.2409 19.3159C27.1683 19.3413 27.1112 19.3977 27.0855 19.4694L26.8657 20.082C26.7854 20.306 26.4646 20.306 26.3843 20.082L26.1645 19.4694C26.1388 19.3977 26.0817 19.3413 26.0091 19.3159L25.3889 19.0989C25.162 19.0195 25.162 18.7027 25.3889 18.6233L26.0091 18.4063C26.0817 18.3809 26.1388 18.3245 26.1645 18.2528L26.3843 17.6402Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2116 8.1148C28.3861 7.6284 29.0826 7.6284 29.2571 8.1148L29.8552 9.78188C29.9111 9.93758 30.0351 10.0601 30.1927 10.1152L31.8806 10.7059C32.3731 10.8783 32.3731 11.5662 31.8806 11.7385L30.1927 12.3292C30.0351 12.3844 29.9111 12.5069 29.8552 12.6626L29.2571 14.3296C29.0826 14.816 28.3861 14.816 28.2116 14.3296L27.6135 12.6626C27.5577 12.5069 27.4337 12.3844 27.276 12.3292L25.5881 11.7385C25.0956 11.5662 25.0956 10.8783 25.5881 10.7059L27.276 10.1152C27.4337 10.0601 27.5577 9.93758 27.6135 9.78188L28.2116 8.1148Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 20.8246C9.75 26.0301 14.0927 30.25 19.4498 30.25C23.5738 30.25 27.0968 27.7491 28.5 24.2229C27.3887 24.7301 26.1477 25.0136 24.8386 25.0136C20.0768 25.0136 16.2165 21.2626 16.2165 16.6355C16.2165 14.7003 16.8917 12.9184 18.0257 11.5C13.3438 12.1694 9.75 16.0892 9.75 20.8246Z",
    stroke: "#929292",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_123_15165",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.172549 0 0 0 0 0.611765 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_123_15165"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_123_15165",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/Moon.f4926063d7594eb9a46652cb1a383b66.svg";
export { ForwardRef as ReactComponent };